import { CashReceiptModel } from "./cash-receipt.model";

export class AdvancePaymentAppliedModel {
  advancePaymentAppliedId: number = 0;
  cashReceiptAppliedId: number = 0;
  cashReceiptApplied: CashReceiptModel = new CashReceiptModel()
  cashReceiptAdvanceId: number = 0;
  cashReceiptAdvance: CashReceiptModel = new CashReceiptModel()
  appliedValue: number = 0;
  createDate: string = "";
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}